import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useQuery } from '@tanstack/react-query';
import { appAgentService } from '../../services/central-api/app-agent';
import { useAuth } from '../../context/Auth';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { useIsFocused } from '@react-navigation/native';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<ViewStyle>;
    onValueChange?: (val: PatrolActivity) => void;
}

export default function PatrolActivityDropdown({ value, setValue, disabled, label, labelFontSize, zIndex, required, labelStyle, viewStyle, onValueChange }: Props) {
    const { user: authenticatedUser } = useAuth();

    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    const isFocused = useIsFocused();
    const queryResult = useQuery({
        queryKey: ['getSimplifiedPatrolActivities'],
        queryFn: () => appAgentService.getSimplifiedPatrolActivities(),
        enabled: !!authenticatedUser && isFocused,
    });

    const isEnabled = !!authenticatedUser;
    const isLoading = isEnabled && queryResult.isFetching;
    const { data } = queryResult;

    useEffect(() => {
        if (!authenticatedUser || !data) {
            return;
        }

        setItems(data.map(activity => ({
            label: `${activity.code} - ${activity.name}`, value: activity.id
        })));
    }, [data, authenticatedUser]);

    useEffect(() => {
        const item = data?.find(i => i.id === value);
        if (item) {
            onValueChange?.(item);
        }
    }, [value, data]);

    return (
        <FilterDropdown
            label={label ?? translate('patrolActivities')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled || isLoading}
            labelFontSize={labelFontSize}
            loading={isLoading}
            required={required}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
